import React, { useState } from "react";
import * as S from "./Nav.styles";
import PropTypes from "prop-types";
import Logo from "../../assets/LKFnew.png";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const token = localStorage.getItem("token");
  let email;

  if (token !== null) {
    const decoded = jwtDecode(token);
    email = decoded.email;
  }

  const navigate = useNavigate();
  return (
    <S.Nav
      scrolled={scrolled}
      onScroll={() => setScrolled(!scrolled)}
      className="navbar scrolled"
    >
      <div className="navbarWrapper">
        <div className="navmenu">
          <S.NavBrand>
            <img src={Logo} alt="LTU Basketball" />
          </S.NavBrand>
        </div>
        {token !== null ? (
          <div className="loggedin">
            <p>Logged in as: {email}</p>
            <button
              className="button is-link is-small"
              onClick={() => {
                localStorage.removeItem("token");
                navigate("/");
              }}
            >
              Logout
            </button>
          </div>
        ) : null}
      </div>
    </S.Nav>
  );
};

Nav.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      active: PropTypes.func,
    }),
  ),
};

export default Nav;
